import i18n from 'i18n'
import MsgBox from '@/plugins/bootstrap/MsgBox'
import { BasketError } from 'proto/eshop/Basket_pb'
import { ServiceError } from './ServiceError'
import { extractErrorDetails } from './ErrorMessages'
import { DiscountError } from './DiscountError'

function getBasketErrorHandler(error: BasketError) {
	switch (error.getCode()) {
		case BasketError.Code.INTERNAL:
			return () => showError(error)
		case BasketError.Code.BAD_REQUEST:
			return () => showError(error)
		case BasketError.Code.FRONTEND_OUT_OF_DATE:
			return () => Promise.resolve(window.location.reload()) // автоматом перезагружаем старницу
		case BasketError.Code.NOT_FOUND:
			return () => showError(error)
		case BasketError.Code.PAYMENT_GATEWAY_UNAVAILABLE:
			return () => showError(error)
	}
}

function getDiscountErrorhandler(error: DiscountError) {
	return () => showError(error)
}

function getServiceErrorHandler(error: ServiceError) {
	return () => showError(error)
}

export function getErrorHandler(error: BasketError | ServiceError | Error) {
	let handler = null
	if (error instanceof BasketError) {
		handler = getBasketErrorHandler(error)
	} else if (error instanceof DiscountError) {
		handler = getDiscountErrorhandler(error)
	} else if ('code' in error) {
		handler = getServiceErrorHandler(error)
	}
	console.error(error)
	return handler || (() => showError(error))
}

export function handleError(error: BasketError | ServiceError | Error) {
	const handler = getErrorHandler(error)
	if (!handler) throw new Error('Error handler not found for: ' + error.toString())
	return handler()
}

export function showError(error: BasketError | ServiceError | DiscountError | Error, title?: string): Promise<any> {
	const { message, name } = extractErrorDetails(error)
	return MsgBox.msgBoxOk(message, {
		title: title || name || i18n.gettext('Error'),
		okVariant: 'warning',
		centered: true,
		headerBgVariant: 'warning',
	})
}

export function hideError(id: string) {
	MsgBox.hide(id)
}
